import { Navigate, Outlet } from "react-router-dom";
import { useAuthState } from "../../context/FirebaseContext";
import Loading from "../Loading";
import { useContext } from "react";
import { FirebaseContext } from "../../context/FirebaseContext";

export const ProtectedRoute = ({ redirectPath, children }) => {
  const { isAuthenticated, loadingUser, user } = useAuthState();
  const { isMaintenanceMode } = useContext(FirebaseContext);


  if (loadingUser) {
    return <Loading />;
  } else {
    // Si está en modo mantenimiento y el usuario no es super admin, redirigir a página de mantenimiento
    if (isMaintenanceMode && (!user || !user.roles?.super)) {
      return <Navigate to="/maintenance-mode" replace />;
    }

    if (!isAuthenticated) {
      return <Navigate to={redirectPath} replace />;
    }
    if (user && !user.acceptLegal && location.pathname !== "/legal" && location.pathname !== "/legal/info") {
      return <Navigate to={"/legal"} replace />;
    } else if (user && user.acceptLegal && location.pathname === "/legal") {
      return <Navigate to={"/"} replace />;
    } else if (user && user.firstTime && user.acceptLegal && location.pathname !== "/change-password") {
      return <Navigate to={"/change-password"} replace />;
    }

    return children ? children : <Outlet />;
  }
};
